// Navbar Burger
// Teilweise von: https://bulma.io/documentation/components/navbar/

document.addEventListener('DOMContentLoaded', () => {
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Wenn auf eines der Elemente geklickt wird, soll dies aktviert werden
    $navbarBurgers.forEach(el => {
        el.addEventListener('click', () => {
            const target = el.dataset.target;
            const $target = document.getElementById(target);
            el.classList.toggle('is-active');
            $target.classList.toggle('is-active');

        });
    });

    // Modal Steuerung
    const survBtn = document.getElementById("survBtn");
    let mod = document.getElementById("modal1");
    const nxtBtn = document.querySelectorAll("button[name=nextBtn]");
    const prevBtn = document.querySelectorAll("button[name=prevBtn]");
    let index = 1;

    //Aktivieren Modal
    survBtn.addEventListener('click', function () {
        mod.classList.add('is-active');
    });

    //Öffnen
    function openModal(mod) {
        mod.classList.add('is-active');
    };

    //Nächster Liste
    function clickNextList(list, event, fn) {
        for (let i = 0, len = list.length; i < len; i++) {
            list[i].addEventListener(event, fn, false);
        };
    };

    //Nächster Ablauf
    function clickNext() {
        closeModal(mod);
        index++;
        let modName = "modal" + index;
        mod = document.getElementById(modName);
        openModal(mod);

    };
    //Vorriger Ablauf
    function clickPrev() {
        closeModal(mod);
        index--;
        let modName = "modal" + index;
        mod = document.getElementById(modName);
        openModal(mod);
    };

    //Ausführen/Kombinieren
    clickNextList(nxtBtn, "click", clickNext);
    clickNextList(prevBtn, "click", clickPrev);

    //Schließen
    function closeModal($el) {
        $el.classList.remove('is-active');
    };

    function closeAllModals() {
        (document.querySelectorAll('.modal') || []).forEach(($modal) => {
            closeModal($modal);
        });
    };

    (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close) => {
        const $target = $close.closest('.modal');

        $close.addEventListener('click', () => {
            closeModal($target);
        });
    });

    document.addEventListener('keydown', (event) => {
        const e = event || window.event;

        if (e.keyCode === 27) { // Escape key
            closeAllModals();
        }
    });
    // Schließen 
    (document.querySelectorAll('.notification .delete') || []).forEach(($delete) => {
        const $notification = $delete.parentNode;

        $delete.addEventListener('click', () => {
            $notification.parentNode.removeChild($notification);
        });
    });

    // Benachrichtigung
    const howBtn = document.getElementById("how_to");

    howBtn.onclick = function () {
        const howBtnCon = confirm("Durch die Weiterleitung werden Ihre Geometrien und Eintragungen gelöscht?");
        if (howBtnCon) {
            window.open("./pages/how_to.html")
        } else {
            return
        }
    };
});